<style>

span{
	margin-left: 1px;
}

.dialog{
	z-index: 1000;
	position: fixed;
	top: 10%;
	left: 50%;
	width: 330px;
	margin-left: -165px;
  max-height: 400px;
  border: 1px white solid;
  border-radius: 25px;
	background-color: #999;
  color: black;
	box-shadow: 0 10px 10px rgba(0,0,0,0.5);
  font-size: 24px;
  overflow-y: auto;
}

.header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
	display: grid;
	grid-template-columns: auto 44px;
  background-color: #999;
  padding: 10px 5px 1px 5px;
  border-bottom: 1px var(--dialogBorder) solid;
}
.title{
	grid-column: 1;
  text-align: left;
}
.close{
	grid-column: 2;
	text-align: center;
	cursor: pointer;
	font-size: 25px;
}

.title-text{
  font-size: 26px;
  text-align: center;
  font-weight: normal;
}

.slot{
  padding: 0 20px 20px 20px;
}

.accept{
	text-align: center;
}

.buttons{
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #999;
}
button:first-child{
  width: 48%;
  border: 0;
}
button{
  width: 48%;
  border: 0;
  padding: 10px 0;
  font-size: 26px;
  border-left: 1px #ccc solid;
  color: black;
}
button:hover{
  background-color: inherit;
}
button:disabled{
  color: rgba(255,255,255,0.2);
}

hr.divider{
  margin: 0;
  border: 0;
  border-top: 1px #ccc solid;
}

</style>

{#if show == true}

<div class="overlay" on:click="{ () => { dispatch('close') } }"></div>

<div class="dialog">
	
  {#if title != "" && close == true }
    <div class="header">
      <div class="title">
        <div class="title-text">{title}</div>
      </div>
      {#if close == true}
        <div class="close" on:click="{ () => { dispatch('close') } }">
          <i class="icon-cancel"></i>
        </div>
      {/if}
      <div class="clear"></div>
    </div>
  {/if}
  
  {#if title != "" && close == false}
    <div>
      <div class="title-text">{title}</div>
    </div>
  {/if}
	
  <div class="slot">
    <slot></slot>
  </div>
	
  <div class="buttons">
    <hr class="divider">
    
    <div>
      <div class="accept">
        {#each buttons as item}
        <button on:click="{ () => {dispatch(item.callback)} }" disabled="{item.disabled}">{item.text}</button>
        {/each}
      </div>
    </div>
  </div>
	
</div>

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let show = true;
export let title = "Dialog";
export let close = true;
export let buttons = [ {text: "send", callback: "send", disabled: false, }, {text: "send2", callback: "send2", disabled: false, }, ];


function buttonHelper(b) {
	for (let i in buttons) {
		if (buttons[i].type == b) {
			return true;
		}
	}
	
	return false;
}

</script>
